import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './app/i18n';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <div 
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL}/main_bg.svg)`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        minHeight: '100vh', 
        width: '100%',
      }}
    >
      <App />
    </div>
  </React.StrictMode>
);

reportWebVitals();